import { render, staticRenderFns } from "./StudentLayout.vue?vue&type=template&id=d652aa40&scoped=true&lang=pug&"
import script from "./StudentLayout.vue?vue&type=script&lang=ts&"
export * from "./StudentLayout.vue?vue&type=script&lang=ts&"
import style0 from "./StudentLayout.vue?vue&type=style&index=0&id=d652aa40&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d652aa40",
  null
  
)

export default component.exports